import React, { Component } from 'react'
import Loader from "react-loader-spinner";
import axios from 'axios'
import ls from 'local-storage'

class Dashboard extends Component {
  constructor(props){
    super(props);   
    this.state = {
      record: [],
      loading: true 
    }        
  }  
  componentDidMount(){
    document.title = "Dashboard" 
    const Axios = axios.create({
      baseURL: process.env.REACT_APP_API_URL, 
    });
    const loginToken = ls.get('loginToken');
    Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken; 
    Axios.get(`${process.env.REACT_APP_API_URL}master/dashboard`)
        .then(result=>{
          if(result.status === 200){
            this.setState({loading: false,record:result.data});  
          }      
        });  
      }
      render() { 
        const { loading} = this.state;
        return (
          <div>
          { loading && (
            <div className="content-wrapper">  
             <div style={{ textAlign: "center" }}>
             <br></br>
             <br></br>      
             <Loader
               type="Puff"
               color="#00BFFF"
               height={600}
               width={600}
               visible={loading}
             /> 
           </div>
           </div>
    )}   
     { !loading && (    
       
        <div className="content-wrapper">  
        <section className="content-header">
          <h1>
            Dashboard
            <small>Version 1.0</small>
          </h1>
          <ol className="breadcrumb">
            <li><i className="fa fa-dashboard"></i> Home</li>
            <li className="active">Dashboard</li>
          </ol>
        </section>
        <section className="content">  
          <div className="row">
            <div className="col-md-12">
            <div className="col-md-3 col-sm-6 col-xs-12">
              <div className="info-box">
                <span className="info-box-icon bg-aqua"><i className="fa fa-gear fa-spin"></i></span>
                <div className="info-box-content">
                  <span className="info-box-text">Total Work</span>
                  <span className="info-box-number" style={{ fontSize: '38px'}}>{this.state.record.worktotal}</span>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-xs-12">
              <div className="info-box">
                <span className="info-box-icon bg-red"><i className="fa fa-tasks faa-wrench animated"></i></span>
                <div className="info-box-content">
                  <span className="info-box-text">Total Partwork</span>
                  <span className="info-box-number" style={{ fontSize: '38px'}}>{ this.state.record.partworktotal}</span>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-xs-12">
              <div className="info-box">
			   <span className="info-box-icon bg-green"><i className="fa fa-check faa-pulse animated "></i></span>
                <div className="info-box-content">
                  <span className="info-box-text">Total Completed Partwork</span>
                  <span className="info-box-number" style={{ fontSize: '38px'}}>{ this.state.record.partworktotalcompleted }</span>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-xs-12">
              <div className="info-box">
                <span className="info-box-icon bg-red"><i className="fa fa-cog fa-spin"></i></span>
                <div className="info-box-content">
                  <span className="info-box-text">Total In Progress Partwork</span>
                  <span className="info-box-number" style={{ fontSize: '38px'}}>{ this.state.record.partworktotalinprogress}</span>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-xs-12">
              <div className="info-box">
                <span className="info-box-icon bg-red"><i className="fa fa-pause-circle faa-tada animated"></i></span>
                <div className="info-box-content">
                  <span className="info-box-text">Total Not Started Partwork</span>
                  <span className="info-box-number" style={{ fontSize: '38px'}}>{ this.state.record.partworktotalnotstarted }</span>
                </div>
              </div>
            </div>			
            <div className="col-md-3 col-sm-6 col-xs-12">
              <div className="info-box">
                <span className="info-box-icon bg-yellow"><i className="fa fa-building faa-flash animated"></i></span>
                <div className="info-box-content">
                  <span className="info-box-text">Total Offices</span>
                  <span className="info-box-number" style={{ fontSize: '38px'}}>{ this.state.record.totaloffices }</span>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 col-xs-12">
              <div className="info-box">
                <span className="info-box-icon bg-aqua"><i className="fa fa-user-secret faa-float animated "></i></span>
                <div className="info-box-content">
                  <span className="info-box-text">Total Contractors</span>
                  <span className="info-box-number" style={{ fontSize: '38px'}}>{ this.state.record.contractor }</span>
                </div>
              </div>
            </div>  
          </div>
		  </div>
		<div className="box">
			<div className="box-body">
                <div className="col-md-6">
                  <p className="text-center">
                    <strong>Work Proposed Graph </strong>
                  </p>
                  <div className="info-box bg-green">
                  <span className="info-box-icon"><i className="fa fa-thumbs-o-up"></i></span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total Approved Work</span>
                    <span className="info-box-number"><b>{ this.state.record.totalapprovedworkproposed }</b>/{ this.state.record.totalworkproposed }</span>
                    <div className="progress">
                    <div className="progress-bar" style={{width : this.state.record.approved_work_per+'%'}}></div>
                    </div>
                    <span className="progress-description">
                    {this.state.record.approved_work_per}% Increase in As On Day
                      </span>
                  </div>
                  </div>      
                  <div className="info-box bg-yellow">
                  <span className="info-box-icon"><i className="ion ion-ios-pricetag-outline"></i></span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total Submitted Work</span>
                    <span className="info-box-number"><b>{ this.state.record.totalsubmmitedworkproposed }</b>/{ this.state.record.totalworkproposed }</span>
                    <div className="progress">
                    <div className="progress-bar" style={{width : this.state.record.submitted_work_per+'%'}}></div>
                    </div>
                    <span className="progress-description">
                    {this.state.record.submitted_work_per}% Increase in As On Day
                      </span>
                  </div>
                  </div>   
                  <div className="info-box bg-red">
                  <span className="info-box-icon"><i className="fa fa-thumbs-o-down"></i></span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total Rejected Work</span>
                    <span className="info-box-number"><b>{ this.state.record.totalrejectedworkproposed }</b>/{ this.state.record.totalworkproposed }</span>
                    <div className="progress">
                    <div className="progress-bar" style={{width : this.state.record.rejected_work_per+'%'}}></div>
                    </div>
                    <span className="progress-description">
                    {this.state.record.rejected_work_per}% Increase in As On Day
                      </span>
                  </div>
                  </div>    
                </div>	
                <div className="col-md-6">
                  <p className="text-center">
                    <strong>Partwork Proposed Graph </strong>
                  </p>
                  <div className="info-box bg-green">
                  <span className="info-box-icon"><i className="fa fa-thumbs-o-up"></i></span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total Approved Partwork</span>
                    <span className="info-box-number"><b>{ this.state.record.totalapprovedpartworkproposed }</b>/{ this.state.record.totalpartworkproposed }</span>
                    <div className="progress">
                    <div className="progress-bar" style={{width : this.state.record.approved_partwork_per+'%'}}></div>
                    </div>
                    <span className="progress-description">
                    {this.state.record.approved_partwork_per}% Increase in As On Day
                      </span>
                  </div>
                  </div>      
                  <div className="info-box bg-yellow">
                  <span className="info-box-icon"><i className="ion ion-ios-pricetag-outline"></i></span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total Submitted Partwork</span>
                    <span className="info-box-number"><b>{ this.state.record.totalsubmmitedpartworkproposed }</b>/{ this.state.record.totalpartworkproposed }</span>
                    <div className="progress">
                    <div className="progress-bar" style={{width : this.state.record.submitted_partwork_per+'%'}}></div>
                    </div>
                    <span className="progress-description">
                    {this.state.record.submitted_partwork_per}% Increase in As On Day
                      </span>
                  </div>
                  </div>   
                  <div className="info-box bg-red">
                  <span className="info-box-icon"><i className="fa fa-thumbs-o-down"></i></span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total Rejected Partwork</span>
                    <span className="info-box-number"><b>{ this.state.record.totalrejectedpartworkproposed }</b>/{ this.state.record.totalpartworkproposed }</span>
                    <div className="progress">
                    <div className="progress-bar" style={{width : this.state.record.rejected_partwork_per+'%'}}></div>
                    </div>
                    <span className="progress-description">
                    {this.state.record.rejected_partwork_per}% Increase in As On Day
                      </span>
                  </div>
                  </div>            

                </div>				
                </div>		  
           </div>
		<div className="box">
			<div className="box-body">
                <div className="col-md-12">
                  <p className="text-center">
                    <strong>Partwork Summary</strong>
                  </p>				  
                  <div className="progress-group">
                    <span className="progress-text">Schedule B and Workorder Value Not Matching</span>
                    <span className="progress-number"><b>{ this.state.record.schedub_vc_workorderamount }</b>/{ this.state.record.partworktotal }</span>
                    <div className="progress sm">
                      <div className="progress-bar progress-bar-red progress-bar-striped" style={{ width: this.state.record.schedule_b+'%' }}></div>
                    </div>
                  </div>
                  <div className="progress-group">
                    <span className="progress-text">Stipulated Date of Completion is crossed but Physical Progress is Less Than 100%</span>
                    <span className="progress-number"><b>{ this.state.record.stipulateddateofcompletion }</b>/{ this.state.record.partworktotal }</span>
                    <div className="progress sm">
                      <div className="progress-bar progress-bar-red progress-bar-striped" style={{ width: this.state.record.stipulated+'%' }}></div>
                    </div>
                  </div>
                  <div className="progress-group">
                    <span className="progress-text">Time Limit File Forwarded But Not Approved</span>
                    <span className="progress-number"><b>{ this.state.record.timelimitfileforwardedbutnotapproved }</b>/{ this.state.record.partworktotal }</span>
                    <div className="progress sm">
                      <div className="progress-bar progress-bar-red progress-bar-striped" style={{ width: this.state.record.timelimitfile+'%' }}></div>
                    </div>
                  </div>
                </div>				
                </div>		  
                </div>
        </section>        	
        </div>)}
      </div>
        )
      }
    }

export default Dashboard
